import {
  Component,
  ElementRef,
  Input,
  OnInit,
  ViewEncapsulation,
  EventEmitter,
  Output,
} from '@angular/core';
import { NotificationService } from 'src/core';

const WRAPPER = 'copy-text-value';
const COPY_VALUE = `${WRAPPER}__value`;
const COPY_MESSAGE = `${WRAPPER}__message`;
const COPY_MESSAGE_SHOW = `${COPY_MESSAGE}--show`;

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'copy-text-value',
  templateUrl: './copyTextValue.component.html',
  styleUrls: ['./copyTextValue.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CopyTextComponent implements OnInit {
  @Input() value = '';
  @Input() message = 'Copiado';
  @Input() useNotification = false;
  @Input() showIcon = false;
  @Output() onCopyToClipboardEvent: EventEmitter<void> = new EventEmitter();

  constructor(
    private el: ElementRef,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {}

  copyValue(): void {
    const textToCopyElement: Element = this.el.nativeElement.querySelector(
      `.${COPY_VALUE} span`,
    );
    if (textToCopyElement) {
      this.copyToClipboard(textToCopyElement.textContent);
      this.showInfoMessage();
    }
  }

  private copyToClipboard(val: string): void {
    const selBox = document.createElement('textarea');

    selBox.style.position = 'fixed';
    selBox.style.left = '0';
    selBox.style.top = '0';
    selBox.style.opacity = '0';
    selBox.value = val.replace(/\s+/g, '');

    document.body.appendChild(selBox);
    selBox.focus();
    selBox.select();

    document.execCommand('copy');
    document.body.removeChild(selBox);

    this.onCopyToClipboardEvent.emit();
  }

  private showInfoMessage(): void {
    if (!this.useNotification) {
      const WAIT_TIME = 800;
      const infoMessageElement = this.el.nativeElement.querySelector(
        `.${COPY_MESSAGE}`,
      );

      if (infoMessageElement) {
        infoMessageElement.classList.add(COPY_MESSAGE_SHOW);
        setTimeout(() => {
          infoMessageElement.classList.remove(COPY_MESSAGE_SHOW);
        }, WAIT_TIME);
      }
    } else {
      this.notificationService.showInfo({
        message: this.message,
        title: 'CLABE',
      } as any);
    }
  }
}
